(() => {
  if (window.tsCoffeeCardUxInitialized) return;
  window.tsCoffeeCardUxInitialized = true;

  const isCoffeeCollection = () => window.location.pathname.includes('/collections/cafes-du-perou');
  const isGiftCollection = () => window.location.pathname.includes('/collections/idees-cadeaux-artisanaux');
  const isHomePage = () => window.location.pathname === '/';
  const isCoffeeMerchandisingContext = () => isCoffeeCollection() || isGiftCollection() || isHomePage();

  const getCoffeeCtaLabel = (button) => {
    const url = button.dataset.productUrl || '';

    if (url.includes('/products/cafe-perou-el-puma')) {
      return 'Acheter en grains';
    }

    if (url.includes('/products/cafe-coya')) {
      return 'Grains ou mouture filtre · 200 g';
    }

    return 'Choisir les options';
  };

  const setButtonLabel = (button, label) => {
    for (const node of button.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        node.textContent = label;
        return;
      }
    }
  };

  const isCardSoldOut = (button) => {
    const card = button.closest('.card-wrapper');
    if (!card) return false;

    return Array.from(card.querySelectorAll('.badge')).some((badge) => {
      const text = badge.textContent.trim().toLowerCase();
      return /épuis|sold out|rupture|indisponible|agotado/.test(text);
    });
  };

  const improveCoffeeCardCtas = () => {
    if (!isCoffeeMerchandisingContext()) return;

    document
      .querySelectorAll('.quick-add__submit[data-product-url*="/products/cafe-"]')
      .forEach((button) => {
        if (isCardSoldOut(button)) {
          setButtonLabel(button, 'Épuisé');
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.removeAttribute('aria-haspopup');
          button.classList.add('button--secondary', 'ts-coffee-sold-out');
          button.classList.remove('ts-coffee-quick-add');
          return;
        }

        if (!isCoffeeCollection() && !isHomePage()) return;

        setButtonLabel(button, getCoffeeCtaLabel(button));
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.setAttribute('aria-haspopup', 'dialog');
        button.classList.remove('button--secondary', 'ts-coffee-sold-out');
        button.classList.add('ts-coffee-quick-add');
      });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', improveCoffeeCardCtas, { once: true });
  } else {
    improveCoffeeCardCtas();
  }

  document.addEventListener('shopify:section:load', improveCoffeeCardCtas);
})();
